import { ArrowLeft } from 'lucide-react';
import { useAuth } from 'core/contexts/authContext';
import ProgressBar from 'shared/components/ProgressBar';
import './styles.scss';
import AppLayout from 'shared/AppLayout';

const PortalPage = () => {
  const { logout, user, userTeam } = useAuth();

  if (!user || !userTeam) {
    return null;
  }

  return (
    <AppLayout
      className="portal-page"
      navButtonComponent={
        <div className="header-btn-container">
          <button className="header-btn" onClick={logout}>
            <ArrowLeft size={16} /> LOG OUT
          </button>
        </div>
      }
    >
      <div className="main-content-portal">
        <section className="team-goal">
          <h2>MY TEAM'S GOAL</h2>
          <ProgressBar
            type="team"
            visits={userTeam.total_visits}
            goal1={userTeam.team_goal_1}
            goal2={userTeam.team_goal_2}
          />
        </section>

        <section className="sessions">
          <h2>MY SESSIONS</h2>
          <ProgressBar
            type="user"
            visits={user.visits}
            goal1={user.user_goal_1}
            goal2={user.user_goal_2}
          />
        </section>

        <section className="prizes">
          <h2>PRIZES ON THE LINE</h2>
          <div className="brackets">
            <div className="bracket">
              <img
                src="/images/bracket1-title.png"
                className="bracket-title-image"
                alt="Bracket-title"
              />
              <div className="bracket-items">
                <div className="bracket-image-container">
                  <img
                    src="/images/bracket-1-prizes.gif"
                    className="bracket-image"
                    alt="Prize"
                  />
                </div>
              </div>
            </div>
            <div className="bracket">
              <img
                src="/images/bracket2-title.png"
                className="bracket-title-image"
                alt="Bracket-title"
              />
              <div className="bracket-items">
                <div className="bracket-image-container">
                  <img
                    src="/images/bracket-2-prizes.gif"
                    className="bracket-image"
                    alt="Prize"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </AppLayout>
  );
};

export default PortalPage;
